import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { ToasterService } from "@shared/services/toaster.service";
import { FE_Bridge } from "@shared/models/integration";
import { AdminIntegrationsApiService } from "@shared/services/admin/admin-integrations-api.service";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { SpinnerComponent } from "../../elements/spinner/spinner.component";
import { IboxComponent } from "../../elements/ibox/ibox.component";
import { LogService } from "@shared/services/log.service";
import { RouterLink } from "@angular/router";

@Component({
    templateUrl: "./bridges.component.html",
    styleUrls: ["./bridges.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SpinnerComponent, IboxComponent, RouterLink, TranslatePipe]
})
export class AdminBridgesComponent implements OnInit {

    public isLoading = true;
    public bridges: FE_Bridge<any>[];

    constructor(private readonly adminIntegrations: AdminIntegrationsApiService,
        private readonly toaster: ToasterService, public translate: TranslateService,
        private readonly logService: LogService,
    ) {
        this.translate = translate;
    }

    public ngOnInit() {
        this.adminIntegrations.getAllBridges().then(bridges => {
            this.bridges = bridges.filter(b => b.isEnabled);
            this.isLoading = false;
        }).catch(err => {
            this.logService.error(err);
            this.translate.get('Failed to load bridges').subscribe((res: string) => {
                this.toaster.pop("error", res);
            });
        });
    }
}
